import React, {useEffect, useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/free-solid-svg-icons';

function Stk({setPay, setStk, setFillin, setDoc, setBackid, setFrontid, ms}) {

  const [phone, setPhone] = useState()

  const cancell = () =>{
    
    ms(false)
  }

  const pay = () =>{

    if (!phone) {
      alert('Please add Phone Number!!')
    } else {
      
    }
    
    ms(false)
    
  }
  return (
    <div  className='inner_TC_MAIN'>
     <div className='Main_MPESA_inner'>
       <FontAwesomeIcon icon={faMobile} className='phoneMpesa' />
       <p className='fee'>Pay a an application fee of 300/-</p>
       <input placeholder='Add Mpesa Number, start with 254 not +254' onChange={(event) => setPhone(event.target.value)} />
       <div className='T_C_Buttons'>
        <button className='acc_BTN' onClick={pay}>pay</button>
        <button className='dec_BTN' onClick={cancell}>don't pay</button>
     </div>
    </div>
    </div>
  )
}

export default Stk